// extracted by mini-css-extract-plugin
export default {"burger_icon":"BurgerIcon_burger_icon__p+6ov","hover":"BurgerIcon_hover__znNHZ","active":"BurgerIcon_active__folcB"};